import { readService, updateService } from "../HttpService";

export const getProfile = (params) => {
  return readService("users/myprofile", params);
};

export const updateProfile = (formData) => {
  return updateService(`users/updateProfile`, {}, formData);
};
